<template>
  <div v-if="this.$route.query.shop_id >= 1" >
    <router-view/>
  </div>
  <div v-else class="faq">
	  <Modal
	    v-model="modalAdd"
	    title="新增店铺"
	    :closable="false"
	    :mask-closable="false"
	    @on-ok="addRecord"
	  >
	  <p>店主邀请码：</p>
	  <Input v-model="inputInviteCode" placeholder="请输入邀请码" clearable />
	  <p>店铺名称：</p>
	  <Input maxlength="20" v-model="inputTitle" placeholder="请输入店铺名称" clearable />
	  <p>店铺故事：</p>
	  <Input maxlength="300" type="textarea" :autosize="{minRows: 7}" v-model="inputIntroduce" placeholder="请输入店铺故事" clearable/>
	  </Modal>
	  
	  <Modal
	    v-model="modalEdit"
	    title="编辑店铺"
	    :closable="false"
	    :mask-closable="false"
	    @on-ok="editRecord"
	  >
	  <p>店铺名称：</p>
	  <Input maxlength="20" v-model="editTitle" placeholder="请输入店铺名称" clearable />
	  <p>店铺故事：</p>
	  <Input maxlength="300" type="textarea" :autosize="{minRows: 7}" v-model="editIntroduce" placeholder="请输入店铺故事" clearable/>
	  </Modal>
	  
	  <div class="headers">
	    <span>功能：</span>
	    <Button @click="modalAdd = true">新增</Button>
        <Button @click="handleManager()">管理全部</Button>
	  </div>
	<Table :columns="columns" :data="data">
	  <template slot-scope="{ row, index }" slot="id">
	    <span>{{ row.id }}</span>
	  </template>
	  <template slot-scope="{ row, index }" slot="title">
	    <span>{{ row.title | ellipsis(20) }}</span>
	  </template>
	  <template slot-scope="{ row, index }" slot="introduce" >
	    <span class="images-text">{{ row.introduce | ellipsis(80) }}</span>
	  </template>
	  <template  slot-scope="{ row, index }" slot="user_id">
	    <span>{{ row.user_id }}</span>
	  </template>
	  <template slot-scope="{ row, index }" slot="created_at">
	    <span>{{ row.created_at }}</span>
	  </template>
	  <template slot-scope="{ row, index }" slot="action">
		    <Button @click="showSelectRow(row, index)">编辑</Button> 
		    <Button style="margin-left: 10px" @click="handleAdd(row, index)">管理</Button> 
	  </template>
	</Table>
  </div>
</template>


<script>
import apis from "../../http/api";

export default {
  name: "faq",
  data() {
    return {
      data: [],
	  modalAdd: false,
	  modalEdit: false,
	  inputInviteCode: null,
	  inputTitle: null,
	  inputIntroduce: null,
	  editShop_id: null,
	  editTitle: null,
	  editIntroduce: null,
      columns: [
        {
          title: '店铺ID',
          slot: 'id',
          width: 80
        },
        {
          title: '店铺名称',
          slot: 'title',
          width: 220
        },
        {
          title: '店铺故事',
          slot: 'introduce',
          // width: 620
        },
        {
          title: '创建者UserId',
          slot: 'user_id',
          width: 170
        },
        {
          title: '创建时间',
          slot: 'created_at',
          width: 170
        },
        {
          title: '操作',
          slot: 'action',
          width: 180
        }
      ]
    }
  },
  async created() {
    await this.getRecords()
  },
  watch: {
	modalAdd: function (newVal, oldVal) {
     if (newVal) {
       // this.addClassify = this.classify;
       // this.addSex = this.sex !== -1 ? this.sex : 1
     }
	},
  },
  methods: {
	  showSelectRow(row, index){
	    this.editShop_id=row.id
		this.editTitle=row.title
		this.editIntroduce=row.introduce
		this.modalEdit = true
	  },
	  async editRecord() {
	  		if (!this.editTitle) {
	  		   this.$Message.error('名称不能为空');
	  		   return
	  		}
	  		if (!this.editIntroduce) {
	  		   this.$Message.error('介绍不能为空');
	  		   return
	  		}
	  		let post_data = {
			  shop_id: this.editShop_id,
	  		  title: this.editTitle,
	  		  introduce: this.editIntroduce
	  		}
	  		await apis.figure_shop_edit(post_data).then(res => {
	  		  const { data, errCode, msg } = res;
	  		  if (errCode === 0) {
				this.editShop_id = null
	  		    this.editTitle = null
	  		    this.editIntroduce = null
	  		  }else {
	  		    this.$Message.error(msg);
	  		  }
	  		}).catch(res => {
	  		  this.$Message.error(res.toString());
	  		})
	    await this.getRecords()
	  },
	  async addRecord() {
		if (!this.inputInviteCode) {
		   this.$Message.error('邀请码不能为空');
		   return
		}
		if (!this.inputTitle) {
		   this.$Message.error('名称不能为空');
		   return
		}
		if (!this.inputIntroduce) {
		   this.$Message.error('介绍不能为空');
		   return
		}
		let post_data = {
		  invite_code: this.inputInviteCode,
		  title: this.inputTitle,
		  introduce: this.inputIntroduce
		}
		await apis.figure_shop_create(post_data).then(res => {
		  const { data, errCode, msg } = res;
		  if (errCode === 0) {
		    this.inputInviteCode = null
		    this.inputTitle = null
		    this.inputIntroduce = null
		  }else {
		    this.$Message.error(msg);
		  }
		}).catch(res => {
		  this.$Message.error(res.toString());
		})
	    await this.getRecords()
	  },
    async getRecords() {
      let params = {
      }
      apis.image_shop_records(params).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          this.data = data.records
        }
      }).catch(err => {

      })
    },
	handleAdd(row, index){
	  this.$router.push({path:'/shop/shop/manager',query: {shop_id:row.id,shop_title:row.title}})
	},
    handleManager(){
      // 不知原因 shop_id<=0 时过不去
      this.$router.push({path:'/shop/shop/manager',query: {shop_id:999,shop_title:'全部店铺'}})
    }
  },
  computed: {
	  
  },
  filters:{
	ellipsis (value,maxLength) {
	  if (!value) return ''
	  if (value.length > maxLength) {
		return value.slice(0,maxLength) + '...'
	  }
	  return value
	}
  }
}
</script>

<style lang="stylus" scoped>
.faq /deep/ .ivu-table-cell {
  min-height: 33px;
  display: flex;
  justify-content center;
  align-items: center;
}

.faq {
  margin: 10px;
}

.headers {
  text-align: center;
  margin-bottom: 10px;
}

.headers button {
  margin-left: 10px;
}

.images-text {
  white-space: pre-wrap;
}

</style>